module.exports = {
  "zones": {
    "Asia/Shanghai": ["z", {
      "wallclock": -649987200000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": 28800000,
      "posix": -650019600000,
      "save": 0,
      "rules": "PRC"
    }, {
      "wallclock": -2177452800000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": 28800000,
      "posix": -2177481943000,
      "save": 0,
      "rules": "Shang"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 29143000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "PRC": [{
      "from": 1986,
      "to": 1991,
      "month": 8,
      "day": [0, 11],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 1991,
      "month": 3,
      "day": [0, 11],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1986,
      "to": 1986,
      "month": 4,
      "day": [7, 4],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }],
    "Shang": [{
      "from": 1948,
      "to": 1949,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1948,
      "to": 1949,
      "month": 8,
      "day": [7, 30],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1947,
      "to": 1947,
      "month": 3,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1947,
      "month": 9,
      "day": [7, 31],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1946,
      "month": 4,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 8,
      "day": [7, 30],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 0,
      "day": [7, 31],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1941,
      "month": 2,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1941,
      "month": 10,
      "day": [7, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 5,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1940,
      "to": 1940,
      "month": 9,
      "day": [7, 12],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};